<template>
  <section id="Stores">
    <div class="mx-n3 mx-md-0">
      <!-- Start Store GoShip -->
      <div>
        <div class="card slide-blog">
          <div class="card-header  header-elements-inline">
            <div class="d-flex align-items-center">
              <div class="mr-2">
                <img
                  width="70px"
                  :src="[planType != 'gosell' ? require(`@/assets/global_assets/images/stores/tab-logo-goship.png`) :require(`@/assets/global_assets/images/stores/tab-logo-gosell.png`)]"
                >
              </div>
              <div>
                <h6 class="card-title">
                  {{ $t("My Stores") }}
                </h6>
                <p>{{ $t("Visit or manage the following connected stores.") }}</p>
              </div>
            </div>
            <div class="header-elements" style="display: none !important;">
              <button
                type="button"
                class="btn btn-primary nowrap"
                @click="$parent.showAlert(planType)"
                :disabled="!$parent.checkClick || $parent.isCreatingStore.length > 0"
              >
                <i class="fa-regular fa-plus mr-1" />{{ $t("Add New Store") }}
              </button>
            </div>
          </div>
          <div class="card-body border-top-1 border-grey-100 pt-3" >
            <div :class="[loadStore ? 'loading' : '']">
              <div class="mx-n3 mx-md-0 position-relative" :class="planType" ref="vueSlickCarouselSection" >
                <div v-if="'data' in dataStore && dataStore.data.length || creatingStore.length">
                  <div v-if="!loadStore">
                    <VueSlickCarousel
                      ref="carousel"
                      @afterChange="afterChange"
                      v-bind="settings"
                      >
                      <!-- <template #nextArrow="arrowOption" > -->

                      <!-- </template> -->
                      <!-- item -->
                      <div
                          v-for="(store) in creatingStore"
                          :key="store.id"
                          :id="'store-' + store.id"
                          class="align-items-center border-bottom cursor-pointer pointer-none d-inline-block card mr-2 card-store-tenant pointer mb-0"
                        >
                          <div class="position-relative card-img-top d-flex justify-content-center p-3 border-bottom-1-e2cdcd">
                            <div
                              class="align-content-center align-items-center d-flex justify-content-center w-90px"
                            >
                              <div
                                :data-load="initailLoad(store , store.progress == 8)"
                                class="rounded_progress_single"
                                id="rounded_progress_single_"
                              />
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="d-flex">
                              <div class="position-relative ">
                                <div
                                  class="border-blue rounded-circle overflow-hidden mx-auto custom-circle-image border-2 w-50px"
                                >
                                  <img
                                    alt
                                    :src="[planType != 'gosell' ? require(`@/assets/global_assets/images/stores/logo-goship.png`) :require(`@/assets/global_assets/images/stores/logo-gosell.png`)]"
                                    class="w-100 h-100"
                                    style="object-fit: cover;"
                                  >
                                </div>
                                <span
                                  class="bg-blue align-items-center d-flex justify-content-center position-absolute right-0 rounded-circle h-16px-w-16px-t-35px"
                                >
                                  <i class="font-size-xxs fa-solid fa-house-user" />
                                </span>
                              </div>
                              <div class="ml-2 store-name">
                                <h6 class="store-title card-title mb-0 line-height-lg mb-1">
                                  {{ store.name }}
                                </h6>
                                <div
                                  class="card-text text-step store-name"
                                  style="font-size: 12px;color: #999999 !important;"
                                />
                              </div>
                            </div>
                          </div>
                      </div>
                      <div
                        class="d-inline-block card mr-2 pointer mb-15px card-store-tenant"
                        style="white-space: normal;"
                        v-for="store in dataStore.data"
                        :key="store.id"
                      >
                        <a
                          v-if="!(store.hasOwnProperty('upgrading') && store.upgrading)"
                          href="#"
                          class="position-absolute right-top"
                          style="z-index: 1;background: #D6F2FF;"
                        >
                          <div class="position-static">
                            <button
                              :disabled="creatingStore.length > 0"
                              type="button"
                              class=" dropdown-toggle btn btn-icon btn-outline btn-sm line-height-1 text-primary-800 "
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-regular fa-ellipsis  font-size-big text-primary-800" />
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a
                                v-if="store.role == 'Owner' && store.owners == 1"
                                @click="storeId = store.id, isDelete = true"
                                data-toggle="modal"
                                data-target="#store-deletion-modal"
                                class="dropdown-item"
                                href="javascript:void(0)"
                              ><i class="fa-regular fa-trash-can fa-1x" />{{ $t('Delete Store') }}</a>
                              <a
                                v-if="store.role != 'Owner'"
                                @click="leaveStore(store.id)"
                                class="dropdown-item"
                                href="javascript:void(0)"
                              ><i class="fa-solid fa-arrow-right-from-bracket fa-1x" />{{ $t('Leave Store') }}</a>
                              <a
                                v-if="store.role == 'Owner' && store.owners > 1"
                                @click="leaveStore(store.id, true)"
                                class="dropdown-item"
                                href="javascript:void(0)"
                              ><i class="fa-solid fa-arrow-right-from-bracket fa-1x" />{{ $t('Leave Store') }}</a>
                            </div>
                          </div>
                        </a>
                        <div @click="handleLogin(store)">
                          <div
                            :class="['position-relative', 'card-img-top d-flex', 'justify-content-center', 'p-3', 'border-grey-DFDFDF', 'border-bottom-1', store.hasOwnProperty('upgrading') && store.upgrading ? '' : 'bg-D6F2FF']"
                          >
                            <div
                              v-if="store.hasOwnProperty('upgrading') && store.upgrading"
                            >
                              <div
                                class="align-content-center align-items-center d-flex justify-content-center w-90px"
                              >
                                <div
                                  :data-load="initailLoadUpgradeStore(store.id, 40)"
                                  class="rounded_progress_single"
                                  :id="'rounded_progress_upgrade_'+ store.id"
                                />
                              </div>
                            </div>
                            <div
                              v-else
                              class="position-relative rounded-circle overflow-hidden mx-auto custom-circle-image bg-white w-90px"
                            >
                            <i
                              v-if="store.logo === 'loading'"
                                class="fa-regular fa-spinner-third d-flex justify-content-center align-items-center fa-spin w-100 h-100 text-secondary h2"
                              />
                              <img
                                v-else
                                alt
                                :src="[store.logo || require(`@/assets/global_assets/images/stores/default-store.png`)]"
                                class="w-100 h-100"
                                style="object-fit: cover;"
                              >
                            </div>
                            <div
                              v-if="store.plan_group == 'gosell' || (store.plan_group == 'goship' && store.plan_serie == 'free')"
                            >
                              <span
                                v-if="store.plan_serie"
                                :class="'bg-'+store.plan_serie"
                                class="badge h-auto position-absolute plan-serie-name"
                                style="right: 10px;bottom: -10px;"
                              >{{ store.plan_serie }}</span>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="d-flex">
                              <div class="position-relative ">
                                <div
                                  :class="[store.role != 'Owner' ? 'border-orange-400' : 'border-blue']"
                                  class="rounded-circle overflow-hidden mx-auto custom-circle-image border-2 w-50px"
                                >
                                  <img
                                    alt
                                    :src="[planType != 'gosell' ? require(`@/assets/global_assets/images/stores/logo-goship.png`) :require(`@/assets/global_assets/images/stores/logo-gosell.png`)]"
                                    class="w-100 h-100"
                                    style="object-fit: cover;"
                                  >
                                </div>
                                <span
                                  :class="[store.role != 'Owner' ? 'bg-orange-400' : 'bg-blue']"
                                  class="align-items-center d-flex justify-content-center position-absolute right-0 rounded-circle h-16px-w-16px-t-35px"
                                >
                                  <i
                                    :class="[store.role != 'Owner' ? 'fa-solid fa-house-person-return' : 'fa-solid fa-house-user']"
                                    class="font-size-xxs"
                                  />
                                </span>
                              </div>
                              <template v-if="!store.name">
                                <placeholder-content  isLoad="true" :line="2" class="ml-2"/>
                              </template>
                              <div class="ml-2 store-name" v-else>
                                <h6
                                  class="store-title card-title mb-0 line-height-lg mb-1"
                                  v-tooltip:top="tooltipTitle(store.name)"
                                >
                                  {{ store.name }}
                                </h6>

                                <div class="card-text store-name">
                                  <div v-if="store.hasOwnProperty('upgrading')">
                                    <span
                                      v-if="store.upgrading && store.percent < 100"
                                      class="text-muted"
                                    >
                                      <i class="fa-solid fa-loader spinner mr-1" /> {{ $t('Updating') }}...
                                    </span>
                                    <span
                                      v-else
                                      class="text-5acf46"
                                    >
                                      <i class="fa-solid fa-circle-check mr-1" /> {{ $t('_Store.Ready') }}
                                    </span>
                                  </div>
                                  <div v-else>
                                    <div v-if="store.last_login">
                                      <span class="text-success">
                                        <i
                                          class="fas fa-check-circle"
                                          style="margin-right: 5px;"
                                        />
                                        {{ $t("Online") }}
                                      </span>
                                    </div>
                                    <div v-else>
                                      <span
                                        v-if="store.domain !== currentLogin"
                                        class="text-muted f-12px"
                                        v-tooltip:top="
                                          tooltip(
                                            convertTimezone(
                                              store.last_login_date ? store.last_login_date : now
                                            )
                                          )
                                        "
                                      >
                                        <i
                                          class="fas fa-circle"
                                          style="margin-right: 3px;"
                                        />
                                        {{ lang == 'en' ? $t("Offline") : $t("Last Login") }}
                                        <span v-if="Number(getDateXDaysAgo(store.last_login_date ? store.last_login_date : now)) > 30">{{ getDateXDaysAgo(store.last_login_date ? store.last_login_date : now) }} {{ $t("day(s) ago") }}</span>

                                        <time-ago
                                          v-else
                                          class="f-12px text-muted"
                                          :datetime="convertTimezone(store.last_login_date ? store.last_login_date : now)"
                                          :locale="$cookie.get('local')"
                                          refresh
                                          long
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- item -->
                    </VueSlickCarousel>
                    <button class="custom-arrow slick-arrow slick-prev d-block" @click="showBack"></button>
                    <button class="custom-arrow slick-arrow slick-next d-block" :disabled="disabledNext" :class="[disabledNext ? 'opcity-80' : '']" @click="showNext"></button>
                  </div>
                </div>
                <div v-else class="d-block text-center">
                    {{ $t('No Data Available') }}
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-delete-store v-if="isDelete" />
  </section>
</template>

<script>
import CentralApi from '@/services/endpoint/central.service'
import TenantApi from '@/services/endpoint/tenant.service'
import TenantAuth from '@/services/auth.tenant.service'
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone";
import { TimeAgo } from "vue2-timeago";
import "vue2-timeago/dist/vue2-timeago.css";
import moment from "moment";
import FiledDef from "./vuetable/FieldsDef.js";
import ModalDeleteStore from "./ModalDeleteStore";
import { localRead } from "@/store/lang";
import VueSlickCarousel from "vue-slick-carousel";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import eventBus from '@/plugins/eventBus';

import Cookies from "js-cookie";

    export default {
        components: {
            TimeAgo,
            ModalDeleteStore,
            VueSlickCarousel,
            PlaceholderContent,

        },
        props: {
            planType:{
                type: String,
                default : ""
            },
            loadingStore : {
                type : Boolean,
            },
            filterData : {
                type : Object,
                default() {
                    return {}
                }
            },
            tempTenant : {
              type : Object,
                default() {
                    return {}
                }
            },
            storeImages : {
                type : Object,
                default() {
                    return {}
                }
            },
            getUserId : {
                type : Number,
                default() {
                    return null
                }
            }
        },
        data() {
            return {
                storeId: '',
                userFirstName: '',
                userLastName: '',
                isDelete: false,
                currentLogin: '',
                protocal: '',
                onload: true,
                limitStore: 0,
                isShowMore: false,
                countStore: 0,
                canAccess: [],
                creatingStore: [],
                emailUser: '',
                locale: "en",
                now: new Date(),
                loadStore: true,
                loading : false,
                dataStore: [],
                table: {
                    field: FiledDef,
                },
                planFree: 'GoShip.co.th (Free)',
                currentStep : [],
                lang: localRead('local'),
                settings : {
                    infinite: false,
                    speed: 600,
                    slidesToShow: 7,
                    slidesToScroll: 5,
                    arrows : false,
                    responsive: [
                    {
                      breakpoint: 2520,
                      settings: {
                        slidesToShow: 8,
                      }
                    },
                    {
                      breakpoint: 2357,
                      settings: {
                        slidesToShow: 8,
                      }
                    },
                    {
                      breakpoint: 2130,
                      settings: {
                        slidesToShow: 7,
                      }
                    },
                    {
                      breakpoint: 1980,
                      settings: {
                        slidesToShow: 7,
                      }
                    },
                    {
                      breakpoint: 1935,
                      settings: {
                        slidesToShow: 6,
                      }
                    },
                    {
                      breakpoint: 1720,
                      settings: {
                        slidesToShow: 5,
                      }
                    },
                    {
                      breakpoint: 1500,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                      }
                    },
                    {
                      breakpoint: 1270,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                      }
                    },
                    {
                      breakpoint: 1050,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                      }
                    },
                  ]
                  },
                slickStep : [],
                disabledNext : false,
                uppatch : [],
                reInitTimeout : null,
                count: 1
            };
        },
        async mounted() {
            const sliceListWidth = this.$refs.vueSlickCarouselSection.clientWidth
            this.settings.slidesToShow = Math.floor(sliceListWidth / 230)
            this.settings.slidesToScroll = this.settings.slidesToShow > 4 ? 5 : this.settings.slidesToShow

            await this.getAccess();

            setTimeout(() => this.upgradeFromTenant(this.$route.query.code), 500);
        },
        watch: {
            '$store.state.central.refreshStore'(){
              if((this.$parent.createType == this.planType) || this.$parent.createType == ''){
                  this.loadStore = this.loadingStore;
                  this.getAccess();
              }
            },
            '$store.state.central.centralUser'(nval, oval){
                this.emailUser = nval.data.data.email;
                this.userFirstName = nval.data.data.first_name,
                this.userLastName = nval.data.data.last_name,
                this.emailUser = nval.data.data.email;
                this.mobileUser = nval.data.data.mobile;
            },
            currentStep : function(val) {
                const length = val.length
                setTimeout(() => this.updateProgress2CreateingTenant(length, 'tenant', 'userAccessId') ,  500)
            },
            storeImages : function(val) {
              if(!("data" in this.dataStore)) return
              this.dataStore.data = this.dataStore.data.map((item) => {
                return {
                  ...item,
                  logo : val[item.id] || ""
                }
              })
            },
        },
        created() {
          this.renderState = [];
          this.min = 36
          this.max = 45
          this.store_upgrade_image = require("@/assets/images/store_upgrade.png"),
          this.protocal = window.location.protocol;
          window.addEventListener("resize", this.handlerWindowResize);

          // UpgradeStoreChannel
          eventBus.on('CreateStore', payload => {
            if(payload.step == 4) {
              if(payload.step == 4 && this.currentStep.length != 4) {
                const left = 4 - this.currentStep.length
                for (let i = 1; i <= left; i++) {
                  setTimeout(() => this.currentStep =  [...this.currentStep, i] , i * 1000)
                }
              }
            } else {
              setTimeout(() => this.currentStep = [...this.currentStep, +(step)] , this.count * 1000)
              this.count++
            }
            eventBus.off('CreateStore', payload)
          })
          // UpgradeStoreChannel
          eventBus.on('UpgradeStore', payload => {
            if (payload.message == "success") {
              this.initailLoadUpgradeStore(payload.tenantId, 100)
            }
            eventBus.off('UpgradeStore', payload)
          })
          //get uppatch from cookies
        },
        destroyed() {
          window.removeEventListener("resize", this.handlerWindowResize);
        },

        methods: {
            convertTimezone(date) {
              return date != null && new Date(date) instanceof Date && !isNaN(new Date(date)) ? convertTimezone.utcToLocal(date) : '-';
            },
            handlerWindowResize() {
              clearTimeout(this.reInitTimeout);

              this.reInitTimeout = setTimeout(() => {

                const skeletonLeft = "data" in this.dataStore && this.dataStore.data.find(({name}) => name === "")

                if(!skeletonLeft) return

                var divElements = document.querySelectorAll('.' + this.planType + ' .slick-track .slick-active');

                let active = [];
                divElements.forEach(function(element) {
                  active.push(+element.getAttribute('data-index'))
                });

                if(active.length === 0) return

                const dataStore = "data" in this.dataStore ? this.dataStore.data : []

                const emptyCard = dataStore.filter(({name}, index) => name === "" && active.includes(index)).length

                if(!emptyCard) return

                this.disabledNext = true
                this.getAccess()
              }, 1000);
            },
            showNext(data){
              this.$refs.carousel.next()
            },
            showBack(data){
              this.$refs.carousel.prev()
            },
            afterChange(){
              const skeletonLeft = "data" in this.dataStore && this.dataStore.data.find(({name}) => name === "")

              if(!skeletonLeft) return

              var divElements = document.querySelectorAll('.' + this.planType + ' .slick-track .slick-active');

              let active = [];
              divElements.forEach(function(element) {
                active.push(+element.getAttribute('data-index'))
              });

              if(active.length === 0) return

              const emptyCard = this.dataStore.data.filter(({name}, index) => name === "" && active.includes(index)).length

              if(!emptyCard) return

              this.disabledNext = true

              this.getAccess()
            },
            async upgradeFromTenant(code){
              if(!code) return

              try {

                const obj = JSON.parse(window.atob(code))

                if("domain" in obj) {
                  const store = this.dataStore.data.filter(item => item.domain === obj.domain.slice(0, -5))[0]
                  store && this.handleLogin(store)
                  return
                }

                if("tenantId" in obj) {
                  const {tenantId} = obj

                  const request = await CentralApi.AppVersions.upGradeVersion(tenantId)

                  if(request.status == 500) {
                    console.error('migrate failed')
                    return
                  }

                  if(request.data.status) {
                    this.dataStore.data = [...this.dataStore.data].map(store => {
                      if(store.id == tenantId) {
                        store.upgrading = true
                        store.percent = this.generateRandom(this.min, this.max)
                      }
                      return store
                    })

                    await this.$store.dispatch("websocket/initWebsocket", `UpgradeStoreChannel${tenantId}`);
                  }
                }


              } catch (error) {
                console.error({error})
              }

            },
            tooltip(data) {
                return moment(data).format('lll');
            },
            tooltipTitle(data) {
                return data;
            },
            initailLoad(store , isTenant = true) {
                this.$nextTick(() => {
                    $("#rounded_progress_single_").html("");
                    let step = isTenant ? +(store.progress) - 4 : 0

                    step = step < this.currentStep.length ? this.currentStep.length : step

                    _roundedProgressSingle("#rounded_progress_single_", 90, 100, '#1d43ff', ((step * 100) / 8),step);

                    const messageCollection = [
                        'Creating a store.',
                        'Step 1 : Adding store information.',
                        'Step 2 : Setting up a store.',
                        'Step 3 : Installing subdomains.',
                        'Step 4 : Created a store.',
                    ]

                    $(".text-step").html(this.$t(messageCollection[step]));
                });
            },
            initailLoadUpgradeStore(tenantId, percent) {
                let obj = [...this.renderState].find(item =>  item.tenantId == tenantId)

                if(percent === 100) {
                  this.uppatch = this.uppatch.filter(item => item != tenantId)
                }

                if(percent > this.max && percent < 100) {
                  this.$nextTick(() => {
                    $("#rounded_progress_upgrade_" + tenantId).html("")
                      _roundedProgressSingle("#rounded_progress_upgrade_" + tenantId, 90, 100, '#1d43ff', Math.ceil(percent))
                  })

                  this.renderState = [...this.renderState,{
                    tenantId,
                    round : 1,
                    progress : percent
                  }]

                return
                }
                const defaultObj = {
                  tenantId,
                  round : 0,
                  progress : 0
                }

                if(obj == undefined){
                  obj = defaultObj
                  this.renderState = [...this.renderState,defaultObj]
                }
                const success = percent >= 100
                const round = (success ? this.generateRandom(8, 10) : this.generateRandom(2, 5))


                if(!success && obj.round > 0) return



                  setTimeout(() => {
                    $("#rounded_progress_upgrade_" + tenantId).html("")
                    _roundedProgressSingle("#rounded_progress_upgrade_" + tenantId, 90, 100, '#1d43ff', 8)

                    if (success) {
                        setTimeout(() => {
                          this.dataStore.data = [...this.dataStore.data].map(store => {
                            if(store.id == tenantId) {
                              store.upgrading = false
                              store.percent = 100

                            }
                            return store
                          })
                        }, 500);
                    }
                  }, 500)


                this.renderState = this.renderState.map(item => {
                  if(item.tenantId == tenantId) {
                    item.round = round
                    item.progress = percent
                  }
                  return item
                })
            },
            async startWebsocketFn(getUserId) {
              this.count = 1;
              await this.$store.dispatch("websocket/initWebsocket", 'CreateStoreChannel' + `${getUserId}`);
            },
            updateProgress2CreateingTenant(step, tenantId, userAccessId) {
                const messageCollection = [
                    'Creating a store.',
                    'Step 1 : Adding store information.',
                    'Step 2 : Setting up a store.',
                    'Step 3 : Installing subdomains.',
                    'Step 4 : Created a store.',
                ]

                this.$nextTick(() => {
                  const percent = (step * 100) / 4;

                  $("#rounded_progress_single_").html("");

                  _roundedProgressSingle("#rounded_progress_single_", 90, 100, '#1d43ff', percent, step);
                  $(".text-step").html(this.$t(messageCollection[step]));


                  if (percent == 100) {
                      const store = this.creatingStore[0]

                      store.tenant = {progress : 8 , name : store.name}
                      store.newStore = true
                      store.role = ["Owner"]
                      store.plan_serie = this.planType == 'goship' ? 'free' : 'professional'
                      store.owners = 1;
                      store.progress = 8
                      store.percent = 100
                      store.name = store.name
                      this.$parent.isCreatingStore = []
                      setTimeout(() => {
                          this.dataStore.data = [store, ...this.dataStore.data]
                          this.creatingStore = []
                          this.onload = false;
                          this.$store.dispatch("central/refreshStore");
                          this.$parent.tempTenant = {}
                          Cookies.remove('tempTenant');
                          this.$parent.isCreate = false;
                          this.$parent.loadingGoSell = false;
                          this.$parent.loadingGoShip = false;
                          this.$toastr.s(this.$t("Create Stores Success"), "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success"));
                      }, 1000);
                  }

                });
            },
            storeUpgradeswal(tenantsId){
              const self = this;

              const content = this.$t("Your version of the store is no longer supported.<br> Please click update to continue using the store.");

              this.$swal.fire({
                  title: this.$t('New Version Available'),
                  iconHtml: `<img src="${this.store_upgrade_image}" class="store-need-upgrade-image" />`,
                  iconColor: '#2196f3',
                  html: this.$t(content),
                  showCancelButton: true,
                  confirmButtonText: '<i class="mr-1 fas fa-check-circle"></i>' + this.$t('Update'),
                  cancelButtonText: this.$t('Cancel'),
                  confirmButtonColor: "#1F88E5",
                  buttonsStyling: false,
                  customClass: {
                      title: 'h5',
                      icon: 'no-border-icon',
                      html: 'body',
                      confirmButton: 'btn btn-primary mr-2',
                      cancelButton: 'btn btn-outline-normal'
                  },
                  focusConfirm: false,
                  showLoaderOnConfirm: true,
                  preConfirm: async () => {
                    const request = await CentralApi.AppVersions.upGradeVersion(tenantsId)

                    self.dataStore.data = [...self.dataStore.data].map(store => {
                      if(store.id == tenantsId) {
                        store.upgrading = true
                        store.percent = this.generateRandom(this.min, this.max)
                      }
                      return store
                    })

                    if(request.data.data.message === 'tenant already up to date') {
                      setTimeout(() => this.initailLoadUpgradeStore(tenantsId, 100), 666);
                      return;
                    }

                    await this.$store.dispatch("websocket/initWebsocket", `UpgradeStoreChannel${tenantsId}`);
                  }
              })
            },
            generateRandom(min = 0, max = 100) {
                return Math.floor( Math.random() * (max - min)) + min;
            },
            async handleLogin(store) {

                if (store.hasOwnProperty('upgrading') && store.upgrading) return;

                let protocal = this.protocal
                let redirectUrl = this.protocal + '//' + store.domain + '.' + process.env.CENTRAL_API_ROOT + process.env.CENTRAL_API_PORT;

                if (this.currentLogin === store.domain) {
                    window.location.href = redirectUrl;
                    return
                }

                if(store.status == 'inactive'){
                  this.handleLoginFail('Inactive Store')
                  return
                }
                if(store.is_maintenance_mode){
                  this.handleLoginFail('The system is under maintenance')
                  return
                }

                if(this.uppatch.includes(store.id)) {
                 this.storeUpgradeswal(store.id)
                 this.$router.replace({ query: null });
                 return;
                }

                var self = this;

                this.$swal.fire({
                    title: this.$t('Shop') + ' ' + store.name,
                    iconHtml: '<i class="fa-regular fa-person-to-door"></i>',
                    iconColor: '#2196f3',
                    html: this.$t('Click confirm to login to your store'),
                    showCancelButton: true,
                    confirmButtonText: '<i class="mr-1 fas fa-check-circle"></i>' + this.$t('Confirm'),
                    cancelButtonText: this.$t('Cancel'),
                    confirmButtonColor: "#1F88E5",
                    buttonsStyling: false,
                    customClass: {
                        title: 'h5',
                        icon: 'no-border-icon',
                        html: 'body',
                        confirmButton: 'btn btn-primary mr-2',
                        cancelButton: 'btn btn-outline-normal'
                    },
                    focusConfirm: false,
                    showLoaderOnConfirm: true,
                    preConfirm: function (password) {
                        return new Promise((resolve, reject) => {

                            const globalId = self.$store.state.central.centralUser.data.data.global_id

                            const apiUrl = protocal + "//" + store.domain + '.' + process.env.TENANT_API_ROOT;

                            TenantAuth.setUrl(apiUrl);

                            TenantAuth.login(globalId).then(function (res) {

                                Cookies.remove(`userProfile`, { domain: '.' + process.env.CENTRAL_API_ROOT })

                                Cookies.remove(`totalStores`, { domain: '.' + process.env.CENTRAL_API_ROOT })

                                Cookies.remove(`migrations_count`, { domain: '.' + process.env.CENTRAL_API_ROOT })

                                resolve()
                            }).catch((error) => {
                                self.loginFail(store, error);
                                console.log(error.response.data.message, 'catch');
                                reject(error.response.data.message);
                            })
                        });
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        //toastr here
                        window.location.href = redirectUrl;
                    }
                }).catch((error) => {
                    console.log(error, 'error2');
                })
            },
            async loginFail(dataStores,error) {
                var titleMessage = this.$t("Great Things Coming Soon…");
                var htmlMessage = this.$t(
                    "The page you’re looking for is currently updating with a new version and will be back soon."
                );

                if(error.response.status === 400 && error.response.data.message == 'Your timestamp outdate') {
                  var titleMessage = this.$t("Unable to Login!");
                  var htmlMessage = this.$t(
                      "Your device's clock is not current. Please enable automatic time setting on your device."
                  );
                }else if(error.response.status === 400 && error.response.data.message == 'User has been blocked.') {
                  var titleMessage = this.$t("Unable to Access to Store!");
                  var htmlMessage = this.$t(
                      "You have been blocked from the store. Please contact the admin."
                  );
                }

                var self = this;
                this.$swal.fire({
                    title: titleMessage,
                    icon: "warning",
                    iconColor: "#FF7043",
                    html: htmlMessage,
                    confirmButtonText: this.$t("Confirm"),
                });
            },
            async handleLoginFail(errorMessage) {
                var titleMessage = this.$t("Great Things Coming Soon…");
                var htmlMessage = this.$t(
                    "The page you’re looking for is currently updating with a new version and will be back soon."
                );

                if(errorMessage == 'Inactive Store') {
                  var titleMessage = this.$t("Inactive Store");
                  var htmlMessage = this.$t(
                      "This store is inactive. Please contact customer support to active this store."
                  );
                }else if(errorMessage == 'The system is under maintenance') {
                  var titleMessage = this.$t("The system is under maintenance");
                  var htmlMessage = this.$t(
                      "Our system is currently undergoing maintenance to improve service performance. We apologize for any inconvenience caused and will resume operations as soon as possible."
                  );
                }

                var self = this;
                this.$swal.fire({
                    title: titleMessage,
                    icon: "warning",
                    iconColor: "#FF7043",
                    html: htmlMessage,
                    confirmButtonText: this.$t("Confirm"),
                });
            },
            getDateXDaysAgo(dateLogin) {
              var date1 = new Date();
              var date2 = new Date(dateLogin);
              var diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10);
              var lastLoginDays = diffDays.toString().replace("-", "")
              return lastLoginDays;
            },
            async getAccess() {

              const getDataStringFromCookie = name => {
                let i = 1
                let fullString = ""
                while (true) {
                  const string = Cookies.get(`${name}-${i}`)

                  if(string === undefined && i === 1) return {
                    message : "cookie is not declare"
                  }

                  Cookies.remove(`${name}-${i}`, { domain: '.' + process.env.CENTRAL_API_ROOT })

                  if(!string) break
                  fullString = fullString + string
                  i++
                }

                if(!fullString) return {
                  message : "full string is empty"
                }

                let store = JSON.parse(fullString)

                const shortVal = {
                  i : "id",
                  d : "domain",
                  l : "last_login_date",
                  m : "migrations_count",
                  n : "name",
                  o : "owners",
                  g : "plan_group",
                  s : "plan_serie",
                  p : "progress",
                  r : "role",
                  u : "upgrading",
                  lo : "logo",
                  st : "status",
                  is : "is_maintenance_mode"
                }

                store = store.map(item => {
                  const obj = {}
                  for (const [key, value] of Object.entries(item)) {
                      obj[shortVal[key]] = value
                  }
                  obj.logo = this.storeImages[item.id] ||obj.logo
                  return obj
                })

                return store
              }

              const setRealDataToSkeletonCard = (dataStoreData, responseObject, responseData) => {

                const skeletonIndex = dataStoreData.findIndex(({name}) => name === "")

                if(skeletonIndex >= 0) {
                  dataStoreData.splice(skeletonIndex, responseData.length, ...responseData)
                }

                this.dataStore = {data : dataStoreData, ...responseObject}
                this.disabledNext = false
              }

              try {
                const stores =  getDataStringFromCookie(`${this.planType}StoreList`);
                const sliceListWidth = this.$refs.vueSlickCarouselSection.clientWidth

                const perPage = Math.ceil(sliceListWidth / 230)

                let storeIsSet = false
                if(Array.isArray(stores)) {

                  const totalStores = JSON.parse(Cookies.get(`totalStores`) || "{}")
                  const totalStoresOfType = totalStores[this.planType]

                  const system_count = Cookies.get(`migrations_count`)


                  const skeletonCardLength = [...Array(totalStoresOfType - stores.length).fill({
                    name: "",
                    logo: "",
                    plan_group:  this.planType,
                    plan_serie: "",
                    domain: "",
                    role: "Owner",
                    owners: "1",
                    progress: "8",
                    last_login_date: "",
                    id:  null,
                    name: "",
                    logo: "",
                    status: "",
                    is_maintenance_mode: "",
                    user_id:  this.getUserId,
                    last_login: null,
                    migrations_count : system_count
                  })].map(item => ({...item,id : (new Date()).getTime()}))

                  stores.push(...skeletonCardLength)

                  this.dataStore = {
                    data : stores,
                    meta : {
                      total : totalStoresOfType
                    }
                  }

                  //check uppatch
                  this.uppatch = stores.filter(({migrations_count}) => migrations_count != system_count).map(({id}) => id)

                  storeIsSet = true
                  const storeLength = stores.filter(({name}) => name).length
                  const leftElement = perPage - storeLength

                  if(leftElement && leftElement < totalStoresOfType) {
                    const queryObject = {
                      viewpoint : this.planType,
                      limit: leftElement,
                      offset: storeLength,
                      sort: "last_login|desc",
                      page : 1,
                    }

                    this.loadStore = false;

                    const queryString = '?' + new URLSearchParams(queryObject).toString();

                    this.disabledNext = true

                    const request = await CentralApi.Auth.getStores(queryString)

                    this.disabledNext = false

                    const {data, ...responseObj} = request.data

                    setRealDataToSkeletonCard(this.dataStore.data, responseObj, data)

                  }
                }

                if("message" in stores && stores.message === "full string is empty") {
                  storeIsSet = true
                  this.dataStore = {
                    data : [],
                    meta : {
                      total : 0
                    }
                  }
                }

                const allOfStoresTypeLength = "data" in this.dataStore ? this.dataStore.data.filter(({name}) => name).length : 0
                // if initialPage = never loaded before
                const initialPage = allOfStoresTypeLength === 0

                if(!storeIsSet) {
                  //second time refresh no need migrations_count cookies
                  Cookies.remove(`migrations_count` , { domain: '.' + process.env.CENTRAL_API_ROOT })

                  const filtered = (this.filterData.filter.searchStore || this.filterData.filter.roles)

                  const limit = (filtered || initialPage) ? perPage : 5

                  const queryObject = {
                    viewpoint : this.planType,
                    sort: "last_login|desc",
                    search : this.filterData.filter.searchStore || "",
                    roles : this.filterData.filter.roles || "",
                    limit,
                    offset : allOfStoresTypeLength
                  }

                  const queryString = '?' + new URLSearchParams(queryObject).toString();
                  this.disabledNext = true

                  const request = await CentralApi.Auth.getStores(queryString)

                  this.disabledNext = false

                  const {data, ...responseObj} = request.data

                  let dataStoreData = "data" in this.dataStore ? this.dataStore.data : []

                  const system_count = responseObj.migrations_count

                  this.uppatch = [...new Set([...this.uppatch, ...data.filter(({migrations_count}) => migrations_count != system_count).map(({id}) => id)])]

                  if(allOfStoresTypeLength === 0) {
                    //first fetch
                      dataStoreData = data

                      const skeletonCardLength = [...Array(responseObj.meta.total - data.length).fill({
                        name: "",
                        logo: "",
                        plan_group:  this.planType,
                        plan_serie: "",
                        domain: "",
                        role: "Owner",
                        owners: "1",
                        progress: "8",
                        last_login_date: "",
                        id:  null,
                        name: "",
                        logo: "",
                        status: "",
                        is_maintenance_mode: "",
                        user_id:  this.getUserId,
                        last_login: null,
                        migrations_count : system_count
                      })].map((item, i) => ({...item,id : ++i}))

                      dataStoreData.push(...skeletonCardLength)
                      this.dataStore = {data : dataStoreData, ...responseObj}
                  } else {
                    // fetch with offset

                    setRealDataToSkeletonCard(dataStoreData, responseObj, data)
                  }

                }

                this.canAccess = [];
                this.dataStore.data.forEach(item => {
                  if(item.progress  == 8) {
                    if('upgrading' in item && item.upgrading) {
                      item.percent = 99
                    }
                    this.canAccess.push(item);
                  } else {
                    this.creatingStore.push(item)
                  }
                })

                 //save current type store in parent


                const findTenant = this.creatingStore.filter(item => item.domain == this.tempTenant.domain)

                const alreadyCreated = this.canAccess.find(item => item.domain == this.tempTenant.domain)

                if(alreadyCreated) {
                  Cookies.remove('tempTenant')
                  this.$parent.tempTenant = {}
                }

                const tenantToken = Cookies.get('tenantToken') ? Cookies.get('tenantToken') : null

                if(findTenant.length == 0 && this.tempTenant.domain && this.tempTenant.plan_group === this.planType && !alreadyCreated) this.creatingStore.unshift(this.tempTenant)

                const online = Cookies.get('online') ? window.atob(Cookies.get('online')) : "";

                this.currentLogin = tenantToken ? online : ""

                //มี tenan token และ domain ของร้าน ตรงกับ domain ที่เก็บไว้ใน cookie
                this.canAccess = this.canAccess.map(item => ({...item, last_login : tenantToken && item.domain == online}))

                this.dataStore.data = this.canAccess;
                this.$parent.canAccess = this.canAccess

                if(this.creatingStore.length) {
                  //หากมีร้านที่กำลังสร้างอยู่
                  this.$parent.isCreatingStore = this.creatingStore
                  const {global_id} = JSON.parse(Cookies.get('userProfile') || Cookies.get('user'))
                  this.startWebsocketFn(global_id)
                }

                if(this.canAccess.length == 0 && this.creatingStore.length == 0) this.$parent.newStore = true

                if(this.loadStore) this.loadStore = false;

                //ถ้าไม่มี meta แสดงว่าไม่ใช่ pagination
                if(this.planType=='gosell'){
                      this.$parent.storesTotalGoSell = this.dataStore.meta.total;
                      this.$parent.loadingGoShip = false;
                  }
                  else{
                      this.$parent.storesTotalGoShip = this.dataStore.meta.total ;
                      this.$parent.loadingGoSell = false;
                  }

                // check ว่ามีบางร้านที่กำลังพแพทอยู่หรือไม่
                const check = this.dataStore.data.filter(item => item.hasOwnProperty('upgrading') && item.upgrading)

                if(check.length) {
                   //หามีให้เปิด websocket รอไว้ก่อน
                  check.map(item => {
                    this.$store.dispatch("websocket/initWebsocket", `UpgradeStoreChannel${item.id}`);
                  })
                }
              } catch (error) {
                console.error({error, line : error.lineNumber})
              }
            },
            leaveStore(tenantId, Owner = false) {

                let tenantID = tenantId;

                let data = {
                    'userId' : this.getUserId,
                    'owner' : Owner,
                };
                this.$swal.fire({
                    icon: 'warning',
                    title: this.$t('Leave Store?'),
                    html: this.$t("You won't be able to undo this action."),
                    focusConfirm: true,
                    showCancelButton: true,
                    confirmButtonText: '<i class="fas fa-check-circle mr-2"></i>'+this.$t('Confirm'),
                    cancelButtonText: this.$t('Cancel'),
                    iconColor: '#FF7043',
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-primary mr-2',
                        cancelButton: 'btn btn-outline-normal'
                    },
                    preConfirm:async () => {
                        return await CentralApi.Tenant.leaveStore(tenantID, data)
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (result.value.data.status) {
                            this.$toastr.s(
                                this.$t("Leave store success"),
                                "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
                            );
                        } else {
                            this.$toastr.e(
                                this.$t("Something went wrong. Please try again."),
                                "<span class='icon-blocked'></span>" + this.$t("Error")
                            );
                        }
                        this.getAccess();
                    }
                })
            },

        }
    };
    // Rounded progress - single arc
    var _roundedProgressSingle = function (element, size, goal, color, percent,step=0 ){

        if (typeof d3 == 'undefined') {
            console.warn('Warning - d3.min.js is not loaded.');
            return;
        }
        // Initialize chart only if element exsists in the DOM
        if (element) {

            // Add random data
            var dataset = function () {
                return [{
                    percentage: percent,
                    step:step
                }];
            };

            // Main variables
            var d3Container = d3.select(element),
                padding = 2,
                strokeWidth = 10,
                width = size,
                height = size,
                τ = 2 * Math.PI;

            // Create chart
            // ------------------------------

            // Add svg element
            //if(!$(element).find('svg')){
            // var container = d3Container.append("svg");
            var container = d3Container.append("i");
            //  }

            // Add SVG group
            // var svg = container
            //     .attr("width", width)
            //     .attr("height", height)
            //     .append("g")
            //     .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

            var svg = container.attr("class", "icon-spinner spinner")
                .attr("style", "font-size:40px;color:#2196F3;");

            // Construct chart layout
            // ------------------------------
            // Foreground arc
            // var arc = d3.svg.arc()
            //     .startAngle(0)
            //     .endAngle(function (d) {
            //         return d.percentage / 100 * τ;
            //     })
            //     .innerRadius((size / 2) - strokeWidth)
            //     .outerRadius((size / 2) - padding)
            //     .cornerRadius(20);

            // // Background arc
            // var background = d3.svg.arc()
            //     .startAngle(0)
            //     .endAngle(τ)
            //     .innerRadius((size / 2) - strokeWidth)
            //     .outerRadius((size / 2) - padding);

            // // Append chart elements
            // // ------------------------------

            // //
            // // Group arc elements
            // //

            // Group
            var field = svg.selectAll("g")
                .data(dataset)
                .enter().append("g");

            // Foreground arc
            // field
            //     .append("path")
            //     .attr("class", "arc-foreground")
            //     .attr('fill', color);

            // // Background arc
            // field
            //     .append("path")
            //     .attr("d", background)
            //     .style({
            //         "fill": color,
            //         "opacity": 0.2
            //     });
            // // field
            // //     .append("text")
            // //     .attr('class', 'arc-goal-completed')
            // //     .attr("transform", "translate(0,04)")
            // //     .style({
            // //         'font-size': 13,
            // //         'fill': '#1d43ff',
            // //         'font-weight': 400,
            // //         'text-anchor': 'middle'
            // //     });

            // //
            // // Animate elements
            // //

            // // Add transition
            d3.transition().each(update);

            // Animation
            function update() {
                field = field
                    .each(function (d) {
                        this._value = d.percentage;
                    })
                    .data(dataset)
                    .each(function (d) {
                        d.previousValue = this._value;
                    });

                // // Foreground arc
                // field
                //     .select(".arc-foreground")
                //     .transition()
                //     .duration(600)
                //     .ease("easeInOut")
                //     .attrTween("d", arcTween);

                // // Update count text
                // field
                //     .select(".arc-goal-completed")
                //     .text(function (d) {
                //         // return Math.round(d.percentage / 100 * goal);
                //          return Math.round(d.percentage);
                //     });

                // // Animate count text
                // svg.select('.arc-goal-completed')
                //     .transition()
                //     .duration(600)
                //     .tween("text", function (d) {
                //         var i = d3.interpolate(this.textContent, d.percentage);
                //         return function (t) {
                //             // this.textContent = Math.floor(d.percentage / 100 * goal) + "%";
                //             this.textContent = (+(percent) > 100 ? 100 : +(percent)) + "%";
                //         };
                //     });

                // Update every 4 seconds (for demo)
                setTimeout(update, 4000);
            }

            // Arc animation
            function arcTween(d) {
                var i = d3.interpolateNumber(d.previousValue, d.percentage);
                return function (t) {
                    d.percentage = i(t);
                    return arc(d);
                };
            }
        }
    };
    </script>
<style>
.slide-blog .card-body .slick-list {
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
.slide-blog .card-body .slick-slider {
  margin: 0 -10px;
}


.slide-blog .card-body .slick-list .card{
  position: relative;
}

.slide-blog .card-body .slick-list .card .right-top{
  right: 0;
  top: 0;
}

.card-store-tenant .border-grey-DFDFDF {
  background-color: #d6f2ff;
}

.card-store-tenant .border-grey-DFDFDF .custom-circle-image {
  width: 90px;
  height: 90px;
}

.w-50px {
  height: 50px;
  width: 50px
}

.f-12px {
  font-size: 12px;
}

.w-90px {
  width: 90px;
  height: 90px;
}

.plan-serie-name {
  right: 10px;
  bottom: -10px;
}

.bg-free {
  background-color: #8bc34a;
}

.bg-basic {
  background-color: #ff5722;
}

.bg-professional {
  background-color: #2196f3;
}

.bg-advance {
  background-color: #673ab7;
}

.bg-vip {
  background-color: #f44336;
}

.opcity-80 {
  opacity: .8;
}


.text-5acf46 {
  color: #5ACF36;
}

.h-16px-w-16px-t-35px {
  height: 16px;
  width: 16px;
  top: 35px;
}

a.right-top {
  z-index: 1;
}

a.right-top .dropdown-toggle::after {
  content: "";
}

.store-need-upgrade-image {
  height: 110.36825561523438px;
  width: 191.24916076660156px;
}

.border-bottom-1-e2cdcd {
  border-bottom: 1px solid #e2cdcd;
}

.slide-blog .card-body button.slick-arrow {
  border: 1px solid #dddddd;
  color: #dddddd;
  z-index: 1;
  height: 35px;
  width: 35px;
  top: calc(50% - 25px);
  border-radius: 3px;
  background-color: #fff;
}

.slide-blog .card-body button.slick-arrow.opcity-80:hover {
  border: 1px solid #dddddd;
  color: #dddddd;
}

.slide-blog .card-body button.slick-arrow:hover {
  border: 1px solid #2196f3;
  color: #2196f3;
}

.slide-blog .card-body button.slick-arrow.slick-prev {
  left: -15px;
}

.slide-blog .card-body button.slick-arrow.slick-next {
  right: -15px;
}

.slide-blog .card-body button.slick-arrow.slick-prev:before {
  color: #dfdfdf;
  content: "\f053";
  font-family: "Font Awesome 5 Pro";
  line-height: 35px;
  font-size: 16px;
  opacity: 1;
}

.slide-blog .card-body button.slick-arrow.slick-next:before {
  color: #dfdfdf;
  content: "\f054";
  font-family: "Font Awesome 5 Pro";
  line-height: 35px;
  font-size: 16px;
  opacity: 1;
}
.slide-blog .card-body button.slick-arrow.slick-prev:hover:before,
.slide-blog .card-body button.slick-arrow.slick-next:hover:before {
  color: #2196f3;
}
.slide-blog .card-body .media-title a {
  word-wrap: break-word;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/central/account/stores/MyStores.vue